import type { TcRunAppraiseeResponse } from '@/api/types/tcRun.types';

// The TC editing window opens at TcReview and remains open through StaffingReview,
// AwaitingHrGuidance, StaffingAccepted, ReadyForDelivery, Delivered — as long as
// approvedForDeliveryAt is null. The terminal lock keys on approvedForDeliveryAt,
// not the status: Appraisal Admin can roll an appraisee forward into a downstream
// status without setting that timestamp, and editing must remain available there.
// DeliveryAcknowledged and pre-TC statuses are excluded from the allowlist.
const TC_EDITABLE_STATUSES = [
  'TcReview',
  'AwaitingHrGuidance',
  'StaffingReview',
  'StaffingAccepted',
  'ReadyForDelivery',
  'Delivered',
] as const;

type TcEditableStatus = (typeof TC_EDITABLE_STATUSES)[number];

function isTcEditableStatus(status: string): status is TcEditableStatus {
  return (TC_EDITABLE_STATUSES as readonly string[]).includes(status);
}

// Derives the section-level read-only flag for a TC Run appraisee.
// Editable while the appraisee status is in the TC editing window AND before
// Approve for Delivery has been pressed. `pageReadOnly` (HR viewer) wins.
export function computeSectionReadOnly(
  appraisee: TcRunAppraiseeResponse | null,
  pageReadOnly: boolean
): boolean {
  if (pageReadOnly) return true;
  if (!appraisee) return true;
  if (!isTcEditableStatus(appraisee.status)) return true;
  if (appraisee.approvedForDeliveryAt) return true;
  return false;
}
